import React from 'react';
import InternalHandover from '../../../components/tools/internalHandover/InternalHandover';

export default function InternalHandoverPage() {
    return (
        <div className="page-wrapper">
            <InternalHandover />
        </div>
    );
}
